<div class="d-flex w-100 h-100 flex-column justify-content-center align-items-center">
    <img src="assets/img/pulpo_error.png" alt="logo" class="logo-error m-4">
    <h2>{{ title }}</h2>
    @if (subtitle) {
      <p class="text-secondary mt-2">{{ subtitle }}</p>
    }
    <button mat-raised-button color="primary" routerLink="/home" class="mt-4">
        Retour à l'accueil
    </button>
</div>
